var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simulationsPage"},[_c('div',{staticClass:"simulationsPage__excludesFooter"},[_c('div',[_c('BHeader')],1),(!_vm.simulations.length)?_c('SimulationsNoneFound'):_c('SimulationsSearch')],1),_c('BFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }